import React from 'react';
import { useCookies } from 'react-cookie';

function CookieBanner({ position = 'left', onAccept, onDecline }) {
  const [, setCookie] = useCookies(['cookieAccepted']);

  const handleAccept = () => {
    setCookie('cookieAccepted', true, { path: '/' });
    onAccept(); 
  };

  const handleDecline = () => {
    setCookie('cookieAccepted', false, { path: '/' });
    onDecline();
  };

  return (
    <div className={`cookie-banner cookie-banner-${position}`}>
      <p>
        By using this website, you agree to our use of cookies to provide support via chat and track usage anonymously.
      </p>
      <button onClick={handleAccept}>OK</button>
      <button onClick={handleDecline}>Decline</button>
    </div>
  );
}

export default CookieBanner;

